import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, Observable } from 'rxjs';

export class Notify {
  stt: string;
  id: string;
  contractId: string;
  title: string;
  requestBy: string;
  receivedBy: string;
  notitficationType: any;
  signGroupDetail: any;
  fromName: string;
  contractCode: string;
  contractName: string;
  fromEnterpriseName: string;
  status: any;
  content: string;
  createdTime: any;
  contractLotId: string;
  objectId: string;
  contractLotType?: string;
  isEmploymentContract?: boolean;
  isDigitalEmploymentContract?: boolean;
}

export class NotifyDataSource extends DataSource<Notify> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Notify[]>([]);

  constructor() {
    super();
  }


  setData(data: Notify[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Notify[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }
}
